import { WarningIcon as PhosphorWarningIcon } from "@phosphor-icons/react/dist/ssr/Warning";

import { createAppIcon } from "@/components/createAppIcon";

export const WarningIcon = /* @__PURE__ */ createAppIcon(PhosphorWarningIcon);
